var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: _vm.classes }, [
    _c("input", {
      staticClass: "trbo-a-checkbox__input",
      attrs: {
        type: "checkbox",
        disabled: _vm.isDisabled,
        "aria-labelledby": _vm.ariaLabelledby,
      },
      domProps: { checked: _vm.isChecked },
    }),
    _vm._v(" "),
    _c("div", { staticClass: "trbo-a-checkbox__box" }, [
      _c(
        "svg",
        {
          staticClass: "trbo-a-checkbox__box__check",
          attrs: {
            width: "18",
            height: "12",
            viewBox: "0 0 18 12",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
          },
        },
        [
          _c("path", {
            attrs: {
              d: "M17.25 0.750488L6.75 11.25L1.5 6.00049",
              "stroke-width": "1.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round",
            },
          }),
        ]
      ),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }